/* istanbul ignore file */
import React, { useEffect, useState } from 'react'
import classnames from 'classnames/bind'
// @ts-ignore no types
import cls from './styles.scss'

const cx = classnames.bind(cls)

export const useIsVerticalOverflow = (
  elementRef: React.RefObject<HTMLDivElement>,
  verticalMaxSize: number
) => {
  const [isOverflow, setIsOverflow] = React.useState(false)
  const checkOverflow = () => {
    if (elementRef.current) {
      const isOverflowing =
        elementRef.current?.scrollHeight > verticalMaxSize + 1
      setIsOverflow(isOverflowing)
    }
  }

  useEffect(() => {
    window.addEventListener('resize', checkOverflow)
    return () => {
      window.removeEventListener('resize', checkOverflow)
    }
  }, [])

  useEffect(() => {
    checkOverflow()
  }, [elementRef, checkOverflow])

  return isOverflow
}

const ExpandableComponent = ({ component, ...rest }: any) => {
  const [showOverlay, setShowOverlay] = useState(false)
  const [isExpanded, setIsExpanded] = useState(false)

  useEffect(() => {
    if (!showOverlay && isExpanded) {
      setIsExpanded(false)
    }
  }, [showOverlay])

  const TargetComponent = component
  return (
    <div className={cx('expandable-container')}>
      {showOverlay && !isExpanded && (
        <div className={cx('overflow-layout')}>
          <a onClick={() => setIsExpanded(true)}>View More</a>
        </div>
      )}
      <TargetComponent
        {...rest}
        setShowOverlay={setShowOverlay}
        isExpanded={isExpanded}
      />
      {isExpanded && (
        <div className={cx('collapse-footer')}>
          <a onClick={() => setIsExpanded(false)}>View Less</a>
        </div>
      )}
    </div>
  )
}

export default ExpandableComponent
